import { DONGWU_SAND_ENTRIES } from '@/config/dongwuAnimals'
import { buildXinliSandEntriesByTab } from '@/config/xinliSand'
import { XIYOU_SAND_ENTRIES } from '@/config/xiyouCharacters'

export function sandEntry (label, emoji, modelRef, thumbUrl) {
  const entry = { label, emoji }
  if (modelRef) {
    if (
      typeof modelRef === 'string' &&
      (modelRef.indexOf('xiyou:') === 0 ||
        modelRef.indexOf('xinli:') === 0 ||
        modelRef.indexOf('dongwu:') === 0)
    ) {
      entry.modelKey = modelRef
    } else {
      entry.modelUrl = modelRef
    }
  }
  if (thumbUrl) entry.thumbUrl = thumbUrl
  return entry
}

/** 列表 v-for / 选中态用的稳定唯一键（同 URL 不同名称时用 label 区分，如太阳花/向日葵） */
export function getSandItemKey (tab, item) {
  if (!item) return ''
  const id = item.modelKey || item.label || item.modelUrl
  return tab + ':' + id
}

const XIYOU_CHARACTER_LABELS = new Set(
  XIYOU_SAND_ENTRIES.map((entry) => entry.label)
)

/** 已有独立 FBX 的西游角色，不用合集裁剪版 */
const XIYOU_STANDALONE_LABELS = new Set([
  '唐僧',
  '孙悟空',
  '沙僧',
  '牛魔王'
])

function xinliEntries (tab) {
  return buildXinliSandEntriesByTab(tab)
    .filter((p) => {
      if (tab !== 'character') return true
      if (XIYOU_STANDALONE_LABELS.has(p.label)) return true
      return !XIYOU_CHARACTER_LABELS.has(p.label)
    })
    .map((p) => {
      const entry = sandEntry(p.label, p.emoji, p.modelKey || p.modelUrl, p.thumbUrl)
      if (p.modelKey && p.modelUrl) entry.modelUrl = p.modelUrl
      return entry
    })
}

/**
 * 沙具五大类 + 天气
 * - 人物：西游 + 心理沙盘/人物
 * - 动物：dongwu 动物库
 * - 植物 / 人造 / 交通：心理沙盘模型库对应目录
 */
export const SAND_CATALOG = {
  character: [
    ...xinliEntries('character'),
    ...XIYOU_SAND_ENTRIES.filter(
      (entry) => !XIYOU_STANDALONE_LABELS.has(entry.label)
    )
  ],
  animal: DONGWU_SAND_ENTRIES.map((p) => {
    const entry = sandEntry(p.label, p.emoji, p.modelKey || p.modelUrl, p.thumbUrl)
    if (p.modelKey) entry.modelKey = p.modelKey
    if (p.modelUrl) entry.modelUrl = p.modelUrl
    return entry
  }),
  plant: xinliEntries('plant'),
  artificial: xinliEntries('artificial'),
  transport: xinliEntries('transport')
}



// WEBPACK FOOTER //
// ./src/config/sandCatalog.js